export const getSubdomain = () => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const subdomain = host.split('.')[0];
    const isSpecialSubdomain = ['awx', 'wyngs-my', 'ae', 'wal', 'localhost', 'uat-speedbox', 'localhost'].includes(
      subdomain,
    );
    return isSpecialSubdomain;
  }
  return false;
};

export const isDutyChargesAllowedSubdomain = (): boolean => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const subdomain = host.split('.')[0];
    return ['ae', 'preprod', 'brightlinkers', 'localhost'].includes(subdomain);
  }
  return false;
};
export const getUsernameFromEmail = (email: string): string => {
  if (!email || !email.includes('@')) {
    return '';
  }
  return email.split('@')[0]; // Extract and return the part before '@'
};
